import { render, staticRenderFns } from "./BaseInputFile.vue?vue&type=template&id=1296a966&scoped=true&"
import script from "./BaseInputFile.vue?vue&type=script&lang=js&"
export * from "./BaseInputFile.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFile.vue?vue&type=style&index=0&id=1296a966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296a966",
  null
  
)

export default component.exports